var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trck-content water-track-right"},[_c('WaterPressureSensors',{staticClass:"info-box"}),_c('WaterPumpStations',{staticClass:"info-box"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }